import { render, staticRenderFns } from "./WarehouseRemain.vue?vue&type=template&id=4f963f14&"
import script from "./WarehouseRemain.vue?vue&type=script&lang=js&"
export * from "./WarehouseRemain.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseRemain.vue?vue&type=style&index=0&id=4f963f14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports